export default __webpack_public_path__ + "static/media/s3.72541ded.png";